var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
import { paint } from "@rendering/neon";
import { layout } from "@rendering/plasma";
import memoize from "lodash.memoize";
import { getPixelSize } from "../utils/getPixelSize";
const warnOnce = memoize(console.warn);
export const fusion = _a => __awaiter(void 0, [_a], void 0, function (_ref) {
  let {
    selectors,
    cimDoc,
    dimension,
    layoutRequestNumberGenerator,
    textOptions,
    getCanvas,
    filters,
    debugOptions,
    experimentalOptions,
    videoOptions,
    referrer
  } = _ref;
  return function* () {
    if (filters === null || filters === void 0 ? void 0 : filters.length) {
      warnOnce("Filters are only rendered client side for demo purposed at the moment.");
    }
    const layoutRequest = layoutRequestNumberGenerator.next();
    // Determine pixel size // TODO: get pixelsize and dimension per page?
    const pixelSize = yield getPixelSize({
      cimDoc,
      dimension,
      selector: selectors[0]
    });
    // Layout
    const layoutResults = yield Promise.all(selectors.map(selector => layout({
      document: cimDoc,
      pixelSize,
      selector,
      textOptions,
      debugOptions,
      experimentalOptions,
      overprints: selector.overprints,
      videoOptions,
      referrer
    })));
    if (layoutRequest !== 0 && layoutRequest < layoutRequestNumberGenerator.lastCompletedRequest()) {
      return null; // Prevent an old layout tyot paint over a newer layout
    }
    layoutRequestNumberGenerator.setLastCompletedRequest(layoutRequest);
    // Paint
    return layoutResults.map((layoutResult, index) => {
      var _a, _b;
      const layoutResultWithFilters = Object.assign(Object.assign({}, layoutResult), {
        filters: (filters === null || filters === void 0 ? void 0 : filters.length) ? [...((_a = layoutResult.filters) !== null && _a !== void 0 ? _a : []), ...filters] : layoutResult.filters
      });
      const selector = selectors[index];
      const canvas = getCanvas({
        cimDocId: cimDoc.documentId,
        selector
      });
      const paintResult = paint({
        layoutResult: layoutResultWithFilters,
        canvasContext: canvas.getContext("2d"),
        pixelSize,
        debugOptions
      });
      const paintResultsOverprints = (_b = selector.overprints) === null || _b === void 0 ? void 0 : _b.map(overprint => {
        const canvas = getCanvas({
          cimDocId: cimDoc.documentId,
          selector,
          overprint
        });
        return {
          paintResult: paint({
            layoutResult: layoutResultWithFilters,
            canvasContext: canvas.getContext("2d"),
            pixelSize,
            debugOptions,
            overprint
          }),
          canvas,
          overprint
        };
      });
      return {
        canvas,
        paintResult,
        layoutResult,
        selector,
        paintResultsOverprints
      };
    });
  }();
});